var timerDelay = 10000;

class Hero extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            current : 0,
            content : this.props.content,
            uuid    : uuid(),
            timer   : false,

            min_w   : 300,
            vid_w_orig : 0,
            vid_h_orig : 0
        };

        this.showSlide = this.showSlide.bind(this);
        this.resizeVideo = this.resizeVideo.bind(this);
    }

    componentDidMount() {
        var self = this;

        var vid_w_orig = parseInt($('#video').attr('width'));
        var vid_h_orig = parseInt($('#video').attr('height'));
        // $('#debug').append("<p>DOM loaded</p>");

        $(window).on('resize', this.resizeToCover);

        // $(window).resize(function () { resizeToCover(); });
        // $(window).trigger('resize');

        this.showSlide(0);

        this.setState({
            vid_w_orig : vid_w_orig,
            vid_h_orig : vid_h_orig,

            timer : setInterval(function() {
                self.showSlide(false)
            }, timerDelay)
        }, () => {
            self.resizeVideo();
        });
    }

    componentWillUnmount() {
        clearInterval(this.state.timer);
        this.setState({ timer : false });
    }

    resizeVideo() {
        console.log('RESIZE VIDEO!!!')

        // var h =
        // var vid_w_orig = this.state.vid_w_orig;
        // var vid_h_orig = this.state.vid_h_orig;
        // // var w =
        // // set the video viewport to the window size
        // $('.hero__video2').width($('.hero__video').width());
        // $('.hero__video2').height($('.hero__video').height());

        // // use largest scale factor of horizontal/vertical
        // var scale_h = $('.hero__video').width() / vid_w_orig;
        // var scale_v = $('.hero__video').height() / vid_h_orig;
        // var scale = scale_h > scale_v ? scale_h : scale_v;

        // // don't allow scaled width < minimum video width
        // if (scale * vid_w_orig < min_w) {scale = min_w / vid_w_orig;};

        // // now scale the video
        // $('#video').width(scale * vid_w_orig);
        // $('#video').height(scale * vid_h_orig);
        // // and center it by scrolling the video viewport
        // $('.hero__video2').scrollLeft(($('#video').width() - $('.hero__video').width()) / 2);
        // $('.hero__video2').scrollTop(($('#video').height() - $('.hero__video').height()) / 2);
    }

    showSlide(slide) {
        var self = this;
        var details = this.state.content.details;

        var next = slide !== false ? slide : this.state.current + 1;

        if (next === details.length) {
            next = 0;
        }

        for (var i=0; i<details.length; i++) {
            if (next === i)
                $('.hero-dot'+i).addClass('hero__controls--current');
            else
                $('.hero-dot'+i).removeClass('hero__controls--current');
        }

        this.setState({
            current: next,
            uuid : uuid()
        }, function() {

            $('.hero__slider--title').animate({
                top: -300,
                opacity: 0
            }, 0, function() {
                $('.hero__slider--title').animate({
                    opacity : 1,
                    top: 0
                }, 1000);
            });

            $('.hero__slider--subtitle').animate({
                top: 200,
                opacity: 0
            }, 0, function() {
                $('.hero__slider--subtitle').animate({
                    opacity : 1,
                    top: 0
                }, 1000);
            });
        });
    }

    render() {
        var self = this;

        var current     = this.state.current;
        var details     = this.state.content.details;

        var title       = details[current].title;
        var subtitle    = details[current].subtitle;

        return (
            <section
                className='hero'
                id='hero'>

                <div className='hero__video'>
                    <video id='video' autoPlay loop muted>
                        <source src='/public/codi-studios/video/hero.mp4' type='video/mp4'></source>
                    </video>
                </div>

                <div className='row hero__content'>
                    <div className='hero__container'>
                        <div className='hero__slider'>
                            <h1
                                className='hero__slider--title'
                                key={"title_"+this.state.uuid}
                                dangerouslySetInnerHTML={{__html: title}} />

                            <h3
                                className='hero__slider--subtitle'
                                key={"subtitle_"+this.state.uuid}
                                dangerouslySetInnerHTML={{__html: subtitle}} />
                        </div>

                    </div>

                    <ul className='hero__controls'>
                        { details.map(function(details, i) {
                            return (
                                <li
                                    className={'hero__controls--dot hero-dot'+i}
                                    onClick={self.showSlide.bind(self, i)}
                                    key={'hero-dot_'+i} />
                            );
                        })}

                    </ul>
                </div>

                <div className='hero__more'>
                    <a className='smoothscroll' href='#services'>
                        MORE ABOUT US <i className="fa fa-angle-down" aria-hidden="true" />
                    </a>
                </div>
            </section>
        );
    }
}

export default Hero;



// WEBPACK FOOTER //
// ./ui_src/app/components/hero/Hero.react.jsx